import React from 'react';

import { useTranslation } from 'react-i18next';
import MiniTab from '../jo-components/misc/miniTab/miniTab';
import NeoLayout from '../neoLayout';
import { OrderList } from './components/orderList';
import { WaitingTicketsList } from './components/waitingTicketsList';
import './homeStep.css';

export function HomeStep({ config, onSubmit=()=>{}, storage }) {
    const home = config.home_step;
    const { orders_list, waiting_list_tickets } = home;
    const { display_waiting_lists = true } = home.settings || [];
    const { t } = useTranslation();

    const miniTabPanes = [{
        value: "orders",
        label: t('widget.home.orders'),
        icon: "",
        disabled: false
    },
    {
        value: "waiting_lists",
        label: t('widget.home.waiting_lists'),
        icon: "",
        disabled: !display_waiting_lists
    }];

    const [activeTab, setActiveTab] = React.useState(miniTabPanes[0].value);

    return (
        <div className="wz-home-step">
            <div>
                <NeoLayout.Header config={{title: home.title}} />
                <NeoLayout.Subtitle config={{subtitle: home.subtitle}} />
            </div>
            <div className="wz-home-step-content">
                <MiniTab panes={miniTabPanes} activeTab={activeTab} onTabSelected={(tab) => setActiveTab(tab.value)}/>
                {activeTab === "orders" && <OrderList config={orders_list} onSubmit={onSubmit} />}
                {activeTab === "waiting_lists" && <WaitingTicketsList config={waiting_list_tickets} onSubmit={onSubmit} />}
            </div>
        </div>
    )
}
